import * as React from 'react'
import { createForm, Button } from '@lacedltd/laced-components'
import Hint from '../../../Hint'
import { pauseListingSchema, PauseListingSchema } from './PauseListing.schema'
import { PauseListingsModalProps, PauseReasonsEnum } from './PauseListing.types'
import * as S from './PauseListing.styles'

const pauseReasonsLabels: Record<PauseReasonsEnum, string> = {
  [PauseReasonsEnum.PENDING_REVIEW]: 'Pending Review',
  [PauseReasonsEnum.FRAUD]: 'Fraud',
  [PauseReasonsEnum.SELLER_LATE_SHIPPING]: 'Seller Late Shipping',
  [PauseReasonsEnum.SELLER_NOT_SHIPPING]: 'Seller Not Shipping',
  [PauseReasonsEnum.SELLER_LOGISTICAL_REASONS]: 'Seller Logistical Reasons'
}

export const PauseListingModal = ({
  handlePauseClick,
  loading,
  error
}: PauseListingsModalProps) => {
  const Form = createForm(pauseListingSchema)

  const methods = Form.useForm({
    defaultValues: {
      pauseReason: '' as PauseReasonsEnum
    }
  })

  const handleSubmit = (data: PauseListingSchema) => {
    handlePauseClick(true, data.pauseReason, data.additionalInformation)
  }

  const generateSelectValues = (): {
    label: string
    value: PauseReasonsEnum
  }[] => {
    return Object.values(PauseReasonsEnum).map((value) => ({
      label: pauseReasonsLabels[value],
      value
    }))
  }

  return (
    <S.PauseFormWrap>
      {error && (
        <Hint type="error" text="There was an error pausing this listing" />
      )}
      <Form.Container methods={methods} onSubmit={handleSubmit}>
        <Form.SelectInput
          name="pauseReason"
          label="Reason for pausing the listing(s)"
          values={generateSelectValues()}
          placeHolder="Select Pause Reason"
        />

        <Form.TextInput name="additionalInformation" label="Additional Info" />

        <Button
          loading={loading}
          variant="primary"
          data-testid="submit-pause-listing"
        >
          Pause Listing(s)
        </Button>
      </Form.Container>
    </S.PauseFormWrap>
  )
}
